/* tslint:disable */
/* eslint-disable */
/**
 * Nightingale API
 *  ### Welcome to the Nightingale API !   To use the Nightingale API, you will need a `access_token` from **Bridgetech Support**  ## How to use swagger documentation   Click `Authorize` and paste your  `access_token` as `bearerAuth`  ## Design Notes 1. For non-mandatory fields, the API will allow you to submit `null` *or* omit fields entirely. 2. All query parameters are optional. Pagination fields default as follows: * page = 1 * limit = 20
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  GetUserGuide200Response,
} from '../models/index';
import {
    GetUserGuide200ResponseFromJSON,
    GetUserGuide200ResponseToJSON,
} from '../models/index';

export interface UpdateUserGuideRequest {
    file: Blob;
    is_static: boolean | null;
}

/**
 * 
 */
export class MiscApi extends runtime.BaseAPI {

    /**
     * Get User Guide
     */
    async getUserGuideRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<GetUserGuide200Response>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/misc/user-guide`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => GetUserGuide200ResponseFromJSON(jsonValue));
    }

    /**
     * Get User Guide
     */
    async getUserGuide(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<GetUserGuide200Response> {
        const response = await this.getUserGuideRaw(initOverrides);
        return await response.value();
    }

    /**
     * Update User Guide
     */
    async updateUserGuideRaw(requestParameters: UpdateUserGuideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['file'] == null) {
            throw new runtime.RequiredError(
                'file',
                'Required parameter "file" was null or undefined when calling updateUserGuide().'
            );
        }

        if (requestParameters['is_static'] == null) {
            throw new runtime.RequiredError(
                'is_static',
                'Required parameter "is_static" was null or undefined when calling updateUserGuide().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("bearerAuth", ["bearerAuth"]);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters['file'] != null) {
            formParams.append('file', requestParameters['file'] as any);
        }

        if (requestParameters['is_static'] != null) {
            formParams.append('is_static', requestParameters['is_static'] as any);
        }

        const response = await this.request({
            path: `/misc/user-guide`,
            method: 'PATCH',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Update User Guide
     */
    async updateUserGuide(requestParameters: UpdateUserGuideRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateUserGuideRaw(requestParameters, initOverrides);
    }

}
